export default __webpack_public_path__ + "static/media/mp_transaction_new.df887d74.svg";